<router-outlet *ngIf="loading == false"></router-outlet>
<app-spashscreen *ngIf="loading == true"></app-spashscreen>